import {Collapse, debounce, Grid} from "@mui/material";
import {useCallback, useEffect, useRef, useState} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {scChoices, scChoicesWithData, scChoicesWithoutData, sliceChoices} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import MhdDatetime from "../../atomicComponents/MhdDatetime";
import dayjs from "dayjs";
import {getCrToDt, getDtToCr} from "../../../utils/api";
import MhdColorbarWidget from "../../atomicComponents/MhdColorbarWidget";
import {debounceInterval} from "../../../utils/globals";
import MhdIntegerInput from "../../atomicComponents/MhdIntegerInput";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";
import {useDatetimeCarringtonConverter} from "../../../hooks/useDatetimeCarringtonConverter";

const ObsWidget = ({data, mods, warn, errs, update, setter, shared}) => {

  const [cr0, setCr0] = useState(null)
  const [cr1, setCr1] = useState(null)
  const [cri, setCri] = useState(null)
  const { dtToCR, crToDT } = useDatetimeCarringtonConverter(setter, update);

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <MhdSelect
          label="Spacecraft (With Flow Speed)"
          value={data.sc_id}
          override={mods.sc_id}
          warning={warn.sc_id}
          error={errs.sc_id}
          onChange={useCallback((v) => setAndUpdate("sc_id", v, setter, update), [])}
          choices={scChoicesWithData}
        />
      </Grid>
      <Grid item xs={6}>
        <MhdSelect
          label="Spacecraft (Without Flow Speed)"
          value={data.sc_id}
          override={mods.sc_id}
          warning={warn.sc_id}
          error={errs.sc_id}
          onChange={useCallback((v) => setAndUpdate("sc_id", v, setter, update), [])}
          choices={scChoicesWithoutData}
        />
      </Grid>
      <Grid item xs={12}>
        <WidgetSwitch
          label="Sync State Time with Ballistic Mappings"
          value={data.sync_state}
          onChange={useCallback((v) => setAndUpdate("sync_state", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={7}>
        <MhdDatetime
          label={"Time Range (Start)"}
          value={data.taxis_min}
          override={mods.taxis_min}
          warning={warn.taxis_min}
          error={errs.taxis_min}
          onChange={useCallback((v) => dtToCR('taxis_min', v, setCr0), [])}
        />
      </Grid>
      <Grid item xs={5}>
        <MhdInput
          label={"CR Range (Start)"}
          value={cr0}
          onChange={useCallback((v) => crToDT('taxis_min', v, setCr0), [])}
          units={"CR"}
          clear={true}
        />
      </Grid>
      <Grid item xs={7}>
        <MhdDatetime
          label={"Time Range (End)"}
          value={data.taxis_max}
          override={mods.taxis_max}
          warning={warn.taxis_max}
          error={errs.taxis_max}
          onChange={useCallback((v) => dtToCR('taxis_max', v, setCr1), [])}
        />
      </Grid>
      <Grid item xs={5}>
        <MhdInput
          label={"CR Range (End)"}
          value={cr1}
          onChange={useCallback((v) => crToDT('taxis_max', v, setCr1), [])}
          units={"CR"}
          clear={true}
        />
      </Grid>
      <Grid item xs={12}>
        <MhdColorbarWidget
          label="Color Palette"
          value={data.color}
          onChange={useCallback((v) => setAndUpdate("color", v, setter, update), [])}
        />
      </Grid>
      
      <Grid item xs={12}>
        <MhdWidgetDivider
            label="QUERY TIME"
            value={data.query_time}
            onChange={useCallback((v) => setAndUpdate('query_time', v, setter, update), [])}
        >
          <Collapse in={data.query_time}>
            <Grid container spacing={1} pt={"2px"}>
              <Grid item xs={7}>
                <MhdDatetime
                  label={"Time of Interest"}
                  value={data.time_tvalue}
                  override={mods.time_tvalue}
                  warning={warn.time_tvalue}
                  error={errs.time_tvalue}
                  onChange={useCallback((v) => dtToCR('time_tvalue', v, setCri), [])}
                />
              </Grid>
              <Grid item xs={5}>
                <MhdInput
                  label={"Time of Interest (CR)"}
                  value={cri}
                  onChange={useCallback((v) => crToDT('time_tvalue', v, setCri), [])}
                  units={"CR"}
                  clear={true}
                />
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Show Text"
                  value={data.show_text}
                  onChange={useCallback((v) => setAndUpdate("show_text", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Point Cloud"
                  value={data.show_point_cloud}
                  onChange={useCallback((v) => setAndUpdate("show_point_cloud", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={2} />
              <Grid item xs={4}>
                <Collapse in={data.show_point_cloud}>
                  <MhdInput
                    label="Cloud Radius"
                    value={data.cloud_sphere_radius}
                    override={mods.cloud_sphere_radius}
                    warning={warn.cloud_sphere_radius}
                    error={errs.cloud_sphere_radius}
                    onChange={useCallback((v) => validateAndUpdate("cloud_sphere_radius", v, setter, update), [])}
                    step={0.1}
                    units={'R⊙'}
                  />
                </Collapse>
              </Grid>
              <Grid item xs={4}>
                <Collapse in={data.show_point_cloud}>
                  <MhdIntegerInput
                    label="Number of Points"
                    value={data.number_of_points}
                    override={mods.number_of_points}
                    warning={warn.number_of_points}
                    error={errs.number_of_points}
                    onChange={useCallback((v) => validateAndUpdate("number_of_points", v, setter, update), [])}
                    min={1}
                    max={64}
                  />
                </Collapse>
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
      
    </Grid>
  );
}

export default ObsWidget;